export default __webpack_public_path__ + "static/media/flow2.242a74b6.svg";